import React, { useState, useEffect, useContext } from "react";
import close from "./assets/close.png";
import ChooseTypeSale from "../ChooseTypeSale/ChooseTypeSale";
import "../ChooseTypeSale/ChooseTypeSale.css";
import ReactDatePicker from "react-datepicker";
import NumericInput from "react-numeric-input";
import CurrencySelection from "../../Pages/MyProfile/CurrencySelection/CurrencySelection";
import thum from "./assets/1.png";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import right from "./assets/arrow-right.png";
import left from "./assets/arrow-left.png";
import { useWeb3React } from "@web3-react/core";
import { Network, Alchemy } from 'alchemy-sdk';
import { useAccount, useFeeData, useNetwork } from "wagmi";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
import MyContext from "../../MyContext";

// import required modules
const LoginModal = ({ open, setOpen, icon1, icon2, gold }) => {
  const [walletNfts, setWalletNfts] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const {address} = useAccount();
  const { login, setLogin } = useContext(MyContext);
  
  const { chain } = useNetwork();
  console.log("address ", address, chain);
  const settings = {
      apiKey: "eTjPJjZScQJ145XEE-0dRHbYCUVkYvwr",
      network: chain.id===421613?"arb-goerli":chain.id===137?"polygon-mainnet":"null",
  };
  const alchemy = new Alchemy(settings);
  const getNfts = async() =>{
    var nfts = await alchemy.nft.getNftsForOwner(address);
    return nfts.ownedNfts;
  }
  const handleWrapClick = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  const handleSelect = (index) =>{
    if(index===activeIndex){
      setActiveIndex(0);
    }
    else{
      setActiveIndex(index);
    }
  }
  const initialize = async() =>{
    var nfts = await getNfts();
    setWalletNfts(nfts);
  }
  useEffect(()=>{
    initialize();
    setInitialized(!initialize);
    console.log("init");
  },[])

  const handleLogin = () =>{
    setLogin(walletNfts[activeIndex]);
    setOpen(false);
  }

  return (
    <div
      //   onClick={handleWrapClick}
        style={{scrollbarWidth: "none",}}
      className="fixed z-10  overflow-y-scroll w-screen top-0 right-0 bottom-0 left-0 flex justify-center items-start  bg-black/30"
    >
      <div className="bg-main-black w-[350px] md:w-[481px] h-max  mt-[60px] md:mt-[100px] rounded-[20px]">
        {/* header */}
        <div className="flex justify-between items-center pt-[31px] pl-[10px] md:pl-[36px] pr-[10px] md:pr-[24px] pb-[20px]">
          <h2 className="text-res-normal font-semibold ">Log In</h2>
          <button
            onClick={() => {
              setOpen(false);
            }}
            style={{
              boxShadow: "0px 0.909091px 1.81818px rgba(165, 163, 174, 0.3)",
            }}
            className="w-[20px] flex justify-center items-center h-[20px] bg-main-green rounded-[2px] "
          >
            <img src={close} alt="close" />
          </button>
        </div>
        <div className="px-[10px] md:pl-[36px] md:pr-[31px]">
          {/* thumbnail area  */}
          <div className=" flex justify-between items-center">
            <div className="flex gap-[10px] items-center">
              <img
                className="w-[100px] h-[100px] rounded-[10px]"
                src={thum}
                alt="thumbnail"
              />
              <div>
                <h2 className="text-res-xs font-bold leading-[26px] ">
                  R34P{" "}
                  {gold ? (
                    <span className="text-[#FFB800]">Gold</span>
                  ) : (
                    "Platinum"
                  )}{" "}
                </h2>
                <h6 className="font-medium text-res-xxs ">
                  {gold ? "Tier 2 NFT" : "Tier 1 NFT"}
                </h6>
              </div>
            </div>
          </div>
          {/* token */}
          <hr className="mt-[52px] border-main-green" />
          {/* chose ara */}
          <div className="mt-[20px]">
            <div>
              <h2 className="text-res-sm font-semibold leading-[24px] mb-[15px]">
                Choose NFT to log in
              </h2>
              
              <Swiper
                slidesPerView={2.5}
                spaceBetween={30}
                freeMode={true}
                navigation={{
                  nextEl: ".image-swiper-button-next",
                  prevEl: ".image-swiper-button-prev",
                }}
                centeredSlidesBounds={true}
                initialSlide={walletNfts.length}
                pagination={{
                  clickable: true,
                }}
                modules={[FreeMode, Pagination, Navigation]}
                className="mySwiper"
                style={{height:"240px"}}
              >
                {
                  walletNfts.map((single,i)=>(
                    <SwiperSlide className=" custome-slide-style">
                      <button
                        onClick={() => handleSelect(i)}
                        className={`text-left w-[150px] px-6 py-6 flex flex-col items-center  bg-[#09090A] h-[200px] rounded-[6px] single-chose-wrap ${
                          activeIndex===i ? "active" : ""
                        }`}
                      >
                        <img src={single.rawMetadata.image}></img>
                            <h4 className="font-semibold mt-[4px] mb-[4px] text-res-ls leading-[22px]">
                              ID:{single.tokenId}
                            </h4>
                            <p style={{textAlign:"center"}}>{single.title}</p>
                      </button>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </div>
          </div>
              <div className="mt-[10px] pb-[52px]">
                <button onClick={()=>{handleLogin()}} className="bg-main-green text-[#0E0E0E] font-bold text-res-xs h-[40px] w-full rounded-[6px]">
                  Log In
                </button>
              </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
